<template>
  <div class="meta-counts is-flex">
    <div v-if="isStory" class="publish-date meta-created meta-data">
      <div class="meta-title">{{ $t('meta-count.published') }}</div> <div><span class="is-size-7 has-text-weight-semibold">{{formatDate(project.published ? project.published: project.created)}}</span></div>
    </div>
    <div v-if="false" class="meta-comments meta-data"> <!-- WIP on project page refresh -->
      <div class="meta-title">{{ $t('meta-count.updates') }}</div> <div><span class="is-size-7 has-text-weight-semibold">{{numPosts}}</span></div>
    </div>
    <div v-if="$isEngCom" class="meta-comments meta-data" :class="{ 'adjust-space' : isMobile }" >
      <div class="meta-title">{{ $t('meta-count.readingTime') }}</div> <div><span class="is-size-7 has-text-weight-semibold" id="readingTime">{{readingTimeInMinutes}} {{ $t('meta-count.minRead') }}</span></div>
    </div>
</div>
</template>

<script>
import auth from '@/mixins/auth'
import moment from 'moment'
import breakpoints from '@/libs/breakpoints'

export default {
  props: ['project', 'post'],
  mixins: [auth],
  data: function () {
    return {
      fetchLimit: 10,
      readingTimeInMinutes: 0
    }
  },
  computed: {
    isStory: function () {
      return this.$route.name === 'viewStory'
    },
    projectMetadata: function () {
      return this.project && this.project.metadata ? this.project.metadata : {}
    },
    numPosts: function () {
      return this.loading ? '-' : this.projectMetadata.posts || 0
    },
    isMobile: function () {
      return breakpoints.isMobile()
    }
  },
  watch: {
    post: function () {
      if (this.post?.body && this.$isEngCom) {
        this.calculateReadingTime()
      }
    }
  },
  methods: {
    formatDate: function (date) {
      return moment(date).format('MMM DD, YYYY')
    },
    calculateReadingTime: function () {
      const wordsPerMinute = 225 // Average case.
      let result
      const textLength = this.post.body.split(' ').length // Split by words
      if (textLength > 0) {
        const value = Math.ceil(textLength / wordsPerMinute)
        result = `~${value}`
      }
      this.readingTimeInMinutes = result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .meta-counts {
    justify-content: space-between;
    font-size: 0.85rem;
    position: relative;
    align-items: flex-start;
    .meta-data {
      flex-direction: column;
    }
    .meta-title {
      font-size: 0.65rem;
      margin-bottom: 0.3rem;
      color: $grey;
      cursor: default;
    }
  }

  .meta-counts.is-hidden-tablet {
    width: 100%;
  }
  .adjust-space {
    margin-left: 1.3rem;
  }
</style>
